import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import api, { formatApiError } from "../lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setDone(true);
            toast.success("If that email exists, we've sent a reset link.");
        } catch (e) {
            toast.error(formatApiError(e));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen grid place-items-center px-6 bg-background">
            <div className="w-full max-w-md glass rounded-3xl p-8">
                <Link to="/" className="inline-flex items-center gap-2 mb-6">
                    <div className="w-9 h-9 rounded-xl bg-white grid place-items-center shadow-[0_0_20px_rgba(255,87,51,0.15)] overflow-hidden p-1">
                        <img src="/logo.png" alt="ParshHR Logo" className="w-full h-full object-contain" />
                    </div>
                    <span className="font-heading font-bold text-xl">ParshHR</span>
                </Link>
                <h1 className="font-heading text-3xl font-bold">Forgot password?</h1>
                <p className="text-muted-foreground text-sm mt-1">Enter your email and we'll send a reset link.</p>

                {done ? (
                    <div className="mt-6 p-4 rounded-xl bg-success/10 text-success text-sm">
                        Check your inbox — a reset link is on its way (valid for 1 hour).
                    </div>
                ) : (
                    <form onSubmit={submit} className="mt-6 space-y-4">
                        <div>
                            <Label htmlFor="email">Email</Label>
                            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="forgot-email" />
                        </div>
                        <Button type="submit" disabled={loading} className="w-full rounded-full h-11" data-testid="forgot-submit">
                            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
                        </Button>
                        <Link to="/login" className="block text-center text-sm text-primary hover:underline">Back to sign in</Link>
                    </form>
                )}
            </div>
        </div>
    );
}
